import insurPeopleReducer from "./reducers";
export { default as insurPeopleTypes } from "./types";
export { default as insurPeopleOperations } from "./operations";
export default insurPeopleReducer;
